import React, { useState, useMemo, useContext } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/navigation"

import ProcessSlider from "../components/process-slider"
import Clients from "../components/clients"
import ProcessNav from "../components/process-nav"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { ViewportContext } from "../contexts/viewport-context"

const ProzessPage = () => {
  useRedirectToLang("/prozess")
  const dimensions = useContext(ViewportContext)
  const [state, setState] = useState("process")

  const handleButtonClick = wantedState => {
    if (state !== wantedState) setState(wantedState)
  }

  return (
    <>
      <SEO title="Prozess" />
      <Layout width={dimensions[0]}>
        {dimensions[0] > 640 ? (
          <ProcessNav navState={state} buttonClick={handleButtonClick} />
        ) : null}
        {useMemo(
          () =>
            state === "process" ? (
              <ProcessSlider>
                {dimensions[0] < 641 ? (
                  <ProcessNav
                    navState={state}
                    buttonClick={handleButtonClick}
                  />
                ) : null}
              </ProcessSlider>
            ) : (
              <Clients>
                {dimensions[0] < 641 ? (
                  <ProcessNav
                    navState={state}
                    buttonClick={handleButtonClick}
                  />
                ) : null}
              </Clients>
            ),
          [state, dimensions[0]]
        )}
      </Layout>
      <Navigation path="/prozess" width={dimensions[0]} />
    </>
  )
}

export default ProzessPage
